import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import AboutTrainingAkmil from "../Components/AboutTraining/AboutTrainingAkmil";
import JumbotronAkmil from "../ComponentAkmil/JumbotronAkmil/JumbotronAkmil";
import Benefit from "../Components/Benefit/Benefit";
import TargetBelajar from "../Components/TargetBelajar/TargetBelajar";
import PaketBelajar from "../Components/PaketBelajar/PaketBelajar";
import SectionDaftar from "../Components/SectionDaftar/SectionDaftar";
import Gallery from "../Components/Gallery/Gallery";
import Fasilitas from "../Components/Fasilitas/Fasilitas";
import MateriAkmil from "../Components/Materi/MateriAkmil";
import Testimoni from "../Components/Testimoni/Testimoni";
import HalDitanyakan from "../Components/HalDitanyakan/HalDitanyakan";
import MasterTeacher from "../Components/MasterTeacher/MasterTeacher";
import Liputan from "../Components/Liputan/Liputan";
import CtaBottom from "../Components/CtaBottom/CtaBottom";
import Footer from "../Components/Footer/Footer";
import FloatCta from "../Components/FloatCta/FloatCta";
import Alumni from "../Components/Alumni/Alumni";
import HalDitanyakanAkmil from "../Components/HalDitanyakan/HalDitanyakanAkmil";
import CtaBottomAkmil from "../Components/CtaBottom/CtaBottomAkmil";
import TargetBelajarAkmil from "../Components/TargetBelajar/TargetBelajarAkmil";

const HalamanAkmil = () => {
  return (
    <React.Fragment>
      <Helmet>
        <meta
          charSet="utf-8"
          name="description"
          content="Bimbel Masuk Akademi TNI (AKMIL) Materi terupdate, fasilitas terlengkap, pengajar profesional & jaminan lulus AKMIL. Bimbel AKMIL terlengkap."
        />
        <title>
          Bimbel Masuk Akademi TNI (AKMIL) Materi terupdate, fasilitas
          terlengkap, pengajar profesional & jaminan lulus AKMIL - Taruna
          Persada
        </title>
        <link
          rel="canonical"
          href="https://camp.tarunapersada.com/bimbel-akmil/"
        />
      </Helmet>
      <Navbar />
      <JumbotronAkmil />
      <AboutTrainingAkmil />
      <Benefit />
      <Alumni />
      <TargetBelajarAkmil />
      <PaketBelajar />
      <SectionDaftar />
      <Gallery />
      <Fasilitas />
      {/* <Cta /> */}
      <MateriAkmil />
      <Testimoni />
      <HalDitanyakanAkmil />
      <MasterTeacher />
      <Liputan />
      <CtaBottomAkmil />
      <Footer />
      <FloatCta />
    </React.Fragment>
  );
};

export default HalamanAkmil;
